module.exports = __webpack_public_path__ + "img/fachada_direction_1_format_1.4996277f.jpg";